import React from "react";
import "./error-message.css";
import "../../shared/styles/shared-styles.css";

const ErrorMessage = (props) => (
  <div className="error-container">
    <span className="validation-error">
      {props.message}
    </span>
  </div>
);

export default ErrorMessage;
